export const toShowDate = (value) => {
  const source = value?.data || value?.date || value?.timestamp || value;

  if (!source) return null;
  if (source instanceof Date) return source;
  if (typeof source?.toDate === 'function') return source.toDate();
  if (typeof source?.seconds === 'number') return new Date(source.seconds * 1000);

  const parsed = new Date(source);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const isLateNightShow = (showOrDate) => {
  const showDate = toShowDate(showOrDate);
  if (!showDate) return false;

  return showDate.getHours() === 23 && showDate.getMinutes() === 59;
};

export const getLateNightShowLiveWindow = (showOrDate) => {
  const showDate = toShowDate(showOrDate);
  if (!showDate || !isLateNightShow(showDate)) return null;

  const start = new Date(showDate);
  start.setSeconds(0, 0);

  const end = new Date(start);
  end.setHours(end.getHours() + 3);
  end.setMinutes(end.getMinutes() + 1, 0, 0);

  return { start, end };
};

export const isShowInLiveWindow = (showOrDate, referenceDate = new Date()) => {
  const window = getLateNightShowLiveWindow(showOrDate);
  const now = toShowDate(referenceDate);

  if (!window || !now) return false;

  return now >= window.start && now < window.end;
};

export const hasScoredParticipations = (participations = []) =>
  participations.some((participant) => {
    const rawPoints = participant?.totalPoints ?? participant?.points;
    const points = Number(rawPoints);

    return Number.isFinite(points) && points !== 0;
  });
